<template>
  <div>
    <section class="footer bg-black py-8 text-white">
      <div class="container">
        <div class="flex flex-col lg:flex-row lg:space-x-4">
          <div class="w-full lg:w-3/12">
            <div class="mb-4">
              <!-- Het idee is als je de titel aanklikt op mobiel dat die openklapt -->
              <div class="font-bold flex justify-between items-center mb-1">
                Over JouwVeilingen.nl
              </div>
              <ul>
                <li><a :href="route('pages.show', ['heeft-u-zelf-iets-te-veilen'])">Heeft u zelf iets te veilen?</a></li>
                <li><a :href="route('pages.show', ['affiliate-programma-webmasters'])">Affiliate Programma Webmasters</a></li>
                <li><a :href="route('pages.show', ['bieden-bij-ons-in-de-veiling'])">Bieden bij ons in de veiling</a></li>
                <li><a :href="route('contact')">Onze Klantenservice</a></li>
              </ul>
            </div>

            <div class="mb-4">
              <div class="font-bold flex justify-between items-center mb-1">
                Overige Veiling Diensten
              </div>
              <ul>
                <li><a :href="route('pages.show', ['met-spoed-franchisers-gezocht'])">Met spoed franchisers gezocht</a></li>
                <li><a :href="route('pages.show', ['huis-ontruimingen-overlijden-of-sterke-vervuiling'])">Huis ontruimen Alphen a/d Rijn</a></li>
                <li><a :href="route('pages.show', ['pop-up-store-alphen-aan-den-rijn'])">Jouwveilingen Pop-up Store Alphen</a></li>
              </ul>
            </div>
          </div>

          <div class="w-full mb-4 lg:w-2/12">
            <div class="font-bold flex justify-between items-center mb-1">
              Informatie
            </div>
            <ul>
              <li><a :href="route('pages.show', ['bieden-bij-ons-in-de-veiling'])">Handleidingen</a></li>
              <li><a :href="route('login')">Inloggen</a></li>
              <li><a :href="route('register')">Registreren</a></li>
              <li><a :href="route('pages.show', ['schema-inpakken-versturen'])">Verzending</a></li>
              <li><a :href="route('pages.faq')">Veelgestelde vragen</a></li>
              <li><a :href="route('pages.show', ['algemene-voorwaarden'])">Algemene voorwaarden</a></li>
              <li><a :href="route('contact')">Contact</a></li>
              <li>
                <Link :href="route('frontend.sitemap.index')">
                  Sitemap
                </Link>
              </li>
            </ul>
          </div>

          <div class="w-full mb-4 lg:w-3/12">
            <div class="font-bold flex justify-between items-center mb-1">
              Laatste nieuws
            </div>
            <ul>
              <li
                v-for="blog in blogs"
                :key="blog.id"
              >
                <a
                  :href="route('blog.show', [blog.slug])"
                  v-text="blog.title"
                />
              </li>
            </ul>
          </div>

          <div class="w-full flex flex-col mb-6 lg:w-5/12 lg:mb-8">
            <div class="flex flex-row w-full mb-4">
              <div class="w-3/5">
                <div class="font-bold">
                  Contact
                </div>
                <p>
                  Jouwveilingen B.V. <br>
                  Titaniumweg 516 <br>
                  2401ML Alphen a/d Rijn
                </p>
              </div>

              <div class="w-2/5">
                <div class="font-bold mb-1">
                  Volg ons via
                </div>
                <div class="space-x-2">
                  <a
                    href="https://nl-nl.facebook.com/jouwveilingen"
                    class="inline-block"
                    target="_blank"
                  ><img src="/img/facebook.svg"> </a>
                  <a
                    href="https://www.instagram.com/jouwveilingen"
                    class="inline-block"
                    target="_blank"
                  ><img src="/img/instagram.svg"> </a>
                </div>
              </div>
            </div>

            <div class="w-full">
              <div class="font-bold mb-1">
                Dagelijks de veilingen in je mailbox?
              </div>
              <Newsletter />
            </div>
          </div>
        </div>

        <div class="mb-6 border-b border-b-gray-800 block" />

        <div class="flex flex-col">
          <div class="flex flex-col mb-2">
            <a
              :href="reviews.place"
              target="_blank"
            >
              <div class="md:flex md:w-full lg:w-7/12 md:mx-auto md:items-center space-y-8 md:space-y-0">
                <div class="w-full text-center">
                  <span class="block mb-2">
                    KiyOh Klantbeoordelingen: <strong>Goed</strong>
                  </span>

                  <Stars
                    class="flex space-x-2 justify-center"
                    star-class="h-8"
                    :rating="reviews.average_rating"
                    full-star="/img/star-green.svg"
                    half-star="/img/star-green-half.svg"
                  />
                </div>

                <div class="w-full">
                  <img
                    src="/img/trustpilot.svg"
                    class="mx-auto"
                  >
                </div>

                <div class="w-full">
                  <img
                    src="/img/comodo.svg"
                    class="mx-auto"
                  >
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>

    <section class="copyright bg-white">
      <div class="container py-4 lg:py-8">
        <div class="flex flex-col lg:flex-row">
          <div class="flex w-full mb-6 lg:w-7/12 lg:mb-0">
            <div class="w-1/6 lg:w-1/12 flex items-center">
              <ConnectionChecker />
            </div>

            <div class="w-5/6 flex justify-end space-x-3 lg:w-11/12 items-center">
              <img
                src="/img/ideal.svg"
                class="lg:max-h-6"
              >
              <img
                src="/img/maestro.svg"
                class="lg:max-h-6"
              >
              <img
                src="/img/mastercard.svg"
                class="lg:max-h-6"
              >
              <img
                src="/img/visa.svg"
                class="lg:max-h-6"
              >
              <img
                src="/img/bancontact.svg"
                class="lg:max-h-6"
              >
            </div>
          </div>

          <div class="w-full text-center text-xs lg:w-5/12 lg:text-right">
            <span class="block">2013 - {{ year }} JouwVeilingen B.V.</span>
            <span class="block">JouwVeilingen B.V. is registered at the chamber of commerce by number 63076934</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue2';
import Stars from './Stars';
import Newsletter from './Newsletter';
import ConnectionChecker from './ConnectionChecker';

export default {
  components: {
    Link,
    ConnectionChecker,
    Newsletter,
    Stars,
  },

  data() {
    return {
      year: new Date().getFullYear(),
      reviews: this.$page.props.reviews,
      blogs: this.$page.props.blogs,
    };
  },
};
</script>
